import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';
import { Theme } from '@material-ui/core/styles/createTheme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    qa: {
      borderBottom: 'solid #ccc 1px',
      marginBottom: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      pageBreakInside: 'avoid',
      '& ul': {
        margin: 0,
      },
      '& img': {
        margin: theme.spacing(1),
      },
      '& li span': {
        display: 'block',
      },
    },
    selectedImg: {
      border: 'solid #000 3px',
    },
    detail: {
      marginTop: theme.spacing(0.5),
    },
    binary: {
      marginLeft: theme.spacing(5),
      display: 'inline-block',
    },

  }),
);

export default useStyles;
